import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getResource = id => {
  return http.get(
    `${getBaseUrl()}/resource/${id}`
  );
};

export const getResources = () => {
  return http.get(
    `${getBaseUrl()}/resource`
  );
};

export const getUserResourceList = () => {
  return http.get(
    `${getBaseUrl()}/user_resource`
  );
};

export const updateResource = data => {

  return http.put(
    `${getBaseUrl()}/resource/${data.id}`,
    data
  );
};
export const submitResource = data => {

  return http.post(
    `${getBaseUrl()}/resource`,
    data
  );
};
